import {useSelector} from "react-redux";
import {RootSliceType} from "redux/reducers/rootReducer";
import {IPurchaseHistory} from "../reducers/purchaseHistorySlice";

export const usePurchaseHistorySelector = () => {
  const purchaseHistory = useSelector<RootSliceType,
    IPurchaseHistory["purchaseHistory"]>((state) => state.purchaseHistory.purchaseHistory);
  const loading = useSelector<RootSliceType,
    IPurchaseHistory["loading"]>((state) => state.purchaseHistory.loading);
  const presentAvailablePointsAmount = useSelector<RootSliceType,
    IPurchaseHistory["presentAvailablePointsAmount"]>((state) => state.purchaseHistory.presentAvailablePointsAmount);
  return {
    presentAvailablePointsAmount,
    loading,
    purchaseHistory
  };
};

export default usePurchaseHistorySelector;